module.exports = __webpack_public_path__ + "img/wp2848452.b821e6b7.png";